import React from 'react';

import { Box, Loader, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ModalLocal } from '@components';
import { modals } from '@modals';

import { useValidationHelper } from './validation.helper';

export const Validation: React.FC = () => {
	const { title } = useValidationHelper();

	return (
		<ModalLocal
			name={modals.validation}
			middleContent={{
				content: (
					<Box
						styles={{
							flexDirection: 'column',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<Loader width={80} height={80} />
						<Spacer vertical={32} />
						<Typography appearance="subtitle-100-04">{title}</Typography>
					</Box>
				),
				type: 'custom',
			}}
		/>
	);
};
